{
    "coordinates": [
        40.06255627092858,
        -1.91682524694383
    ],
    "tooltip": "Las Hoyas",
    "title": "La Huérguina Formation (Las Hoyas)",
    "country": "Spain",
    "period": "Cretaceous",
    "alt": "TODO"
}